<ngx-ui-loader></ngx-ui-loader>

<!-- Server Unreachable Banner -->
<div class="connection-banner" *ngIf="!isServerReachable && user">
  <mat-icon>cloud_off</mat-icon>
  <span>Server non raggiungibile. Verifica la connessione di rete. Alcune funzionalità potrebbero non essere
    disponibili.</span>
</div>

<!-- Toolbar -->
<mat-toolbar color="primary" *ngIf="user" [class.with-banner]="!isServerReachable" class="main-toolbar">
  <button mat-icon-button (click)="toggleSidenav()" class="menu-button">
    <mat-icon>menu</mat-icon>
  </button>

  <span class="toolbar-title" *ngIf="!isCollapsed">Backoffice Meloni</span>
  <span class="toolbar-title-collapsed" *ngIf="isCollapsed">MB</span>

  <span class="toolbar-spacer"></span>
</mat-toolbar>

<mat-sidenav-container class="container">
  <mat-sidenav #sidenav mode="side" [opened]="sidenavOpened && user" class="app-sidenav"
    [class.collapsed]="isCollapsed">
    <div class="sidenav-header" *ngIf="user">
      <div class="user-info-header" *ngIf="!isCollapsed">
        <mat-icon>account_circle</mat-icon>
        <div class="user-details">
          <span class="user-email">{{ user.email }}</span>
          <span class="version-text">{{ versionNumber }}</span>
        </div>
      </div>
      <div class="user-info-header-collapsed" *ngIf="isCollapsed" matTooltip="{{ user.email }}">
        <mat-icon>account_circle</mat-icon>
      </div>

      <button mat-stroked-button (click)="logout()" class="logout-button-header" *ngIf="!isCollapsed">
        <mat-icon>logout</mat-icon>
        Logout
      </button>
      <button mat-icon-button (click)="logout()" class="logout-button-collapsed" *ngIf="isCollapsed"
        matTooltip="Logout">
        <mat-icon>logout</mat-icon>
      </button>
    </div>

    <mat-nav-list class="sidenav-nav">
      <a mat-list-item [routerLink]="'/'" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
        matTooltip="Home" >
        <mat-icon matListItemIcon>home</mat-icon>
        <span matListItemTitle *ngIf="!isCollapsed">Home</span>
      </a>

      <mat-divider></mat-divider>

      <!-- B2C Section -->
      <mat-expansion-panel *ngIf="menu.includes('b2c') && !isCollapsed" class="nav-expansion-panel">
        <mat-expansion-panel-header>
          <mat-panel-title class="expansion-title">
            <mat-icon>storefront</mat-icon>
            <span>B2C</span>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <a mat-list-item [routerLink]="'/b2c/promo'" routerLinkActive="active">
          <mat-icon matListItemIcon>local_offer</mat-icon>
          <span matListItemTitle *ngIf="!isCollapsed">Promozioni</span>
        </a>

        <a mat-list-item [routerLink]="'/b2c/buoni'" routerLinkActive="active">
          <mat-icon matListItemIcon>receipt_long</mat-icon>
          <span matListItemTitle *ngIf="!isCollapsed">Buoni</span>
        </a>

        <a mat-list-item [routerLink]="'/b2c/volantini'" routerLinkActive="active">
          <mat-icon matListItemIcon>sticky_note_2</mat-icon>
          <span matListItemTitle *ngIf="!isCollapsed">Volantini</span>
        </a>

        <a mat-list-item [routerLink]="'/b2c/notifiche-app'" routerLinkActive="active">
          <mat-icon matListItemIcon>alarm_add</mat-icon>
          <span matListItemTitle *ngIf="!isCollapsed">Notifiche Push App</span>
        </a>

        <a mat-list-item [routerLink]="'/b2c/page-fidelity'" routerLinkActive="active">
          <mat-icon matListItemIcon>card_membership</mat-icon>
          <span matListItemTitle *ngIf="!isCollapsed">Fidelity Check</span>
        </a>

        <a mat-list-item [routerLink]="'/b2c/thermo-virtuale'" routerLinkActive="active">
          <mat-icon matListItemIcon>precision_manufacturing</mat-icon>
          <span matListItemTitle *ngIf="!isCollapsed">Thermo Virtuale</span>
        </a>

        <a mat-list-item [routerLink]="'/b2c/prezzi-variati'" routerLinkActive="active">
          <mat-icon matListItemIcon>euro_symbol</mat-icon>
          <span matListItemTitle *ngIf="!isCollapsed">Variazioni Prezzi</span>
        </a>

        <a mat-list-item [routerLink]="'/b2c/gestione-loghi'" routerLinkActive="active">
          <mat-icon matListItemIcon>image</mat-icon>
          <span matListItemTitle *ngIf="!isCollapsed">Gestione Loghi</span>
        </a>

        <a mat-list-item [routerLink]="'/b2c/gestione-bundle'" routerLinkActive="active">
          <mat-icon matListItemIcon>move_to_inbox</mat-icon>
          <span matListItemTitle *ngIf="!isCollapsed">Gestione Bundle</span>
        </a>

        <a mat-list-item [routerLink]="'/b2c/gestione-documenti'" routerLinkActive="active">
          <mat-icon matListItemIcon>description</mat-icon>
          <span matListItemTitle *ngIf="!isCollapsed">Gestione Documenti</span>
        </a>

        <a mat-list-item [routerLink]="'/b2c/otp'" routerLinkActive="active">
          <mat-icon matListItemIcon>vpn_key</mat-icon>
          <span matListItemTitle *ngIf="!isCollapsed">OTP</span>
        </a>

        <a mat-list-item [routerLink]="'/b2c/articoli-contingentati'" routerLinkActive="active">
          <mat-icon matListItemIcon>inventory</mat-icon>
          <span matListItemTitle *ngIf="!isCollapsed">Articoli Contingentati</span>
        </a>
      </mat-expansion-panel>

      <!-- Collapsed B2C Icon -->
      <a mat-list-item *ngIf="menu.includes('b2c') && isCollapsed" (click)="isCollapsed = false"
        matTooltip="B2C - Clicca per espandere">
        <mat-icon matListItemIcon>storefront</mat-icon>
      </a>

      <!-- B2B Section -->
      <mat-expansion-panel *ngIf="menu.includes('b2b') && !isCollapsed" class="nav-expansion-panel">
        <mat-expansion-panel-header>
          <mat-panel-title class="expansion-title">
            <mat-icon>store</mat-icon>
            <span>B2B</span>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <a mat-list-item [routerLink]="'/b2b/testate'" routerLinkActive="active">
          <mat-icon matListItemIcon>local_offer</mat-icon>
          <span matListItemTitle *ngIf="!isCollapsed">Promozioni</span>
        </a>

        <a mat-list-item [routerLink]="'/b2b/categorie'" routerLinkActive="active">
          <mat-icon matListItemIcon>style</mat-icon>
          <span matListItemTitle *ngIf="!isCollapsed">Categorie</span>
        </a>

        <a mat-list-item [routerLink]="'/b2b/articoliCheck'" routerLinkActive="active">
          <mat-icon matListItemIcon>local_mall</mat-icon>
          <span matListItemTitle *ngIf="!isCollapsed">Articoli Check</span>
        </a>

        <a mat-list-item [routerLink]="'/b2b/contingentati'" routerLinkActive="active">
          <mat-icon matListItemIcon>dashboard</mat-icon>
          <span matListItemTitle *ngIf="!isCollapsed">Articoli contingentati</span>
        </a>

        <a mat-list-item [routerLink]="'/ordini'" routerLinkActive="active" *ngIf="menu.includes('ordini')">
          <mat-icon matListItemIcon>inventory_2</mat-icon>
          <span matListItemTitle *ngIf="!isCollapsed">Ordini</span>
        </a>
      </mat-expansion-panel>

      <!-- Collapsed B2B Icon -->
      <a mat-list-item *ngIf="menu.includes('b2b') && isCollapsed" (click)="isCollapsed = false"
        matTooltip="B2B - Clicca per espandere">
        <mat-icon matListItemIcon>store</mat-icon>
      </a>

      <!-- Utenti Section -->
      <a mat-list-item [routerLink]="'/utenti'" routerLinkActive="active" *ngIf="menu.includes('utenti')"
        matTooltip="Utenti" >
        <mat-icon matListItemIcon>people</mat-icon>
        <span matListItemTitle *ngIf="!isCollapsed">Utenti</span>
      </a>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content>
    <div class="content" role="main">
      <div class="app-container" [ngClass]="{ 'bg-light': user }">
        <app-alert></app-alert>
        <router-outlet></router-outlet>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

<!-- Footer -->
<footer class="flex-row md-padding">
  <div id="copyright">
    <p>{{ title }} <small>{{versionNumber}}</small></p>
    <p> <small>{{ copyright }}</small></p>
  </div>
</footer>